export default __webpack_public_path__ + "static/media/product-image-27.90e2f453.jpg";